import type { RichtextSectionProps } from '.'
import type { WebUiSection } from '@/kontent/content-types/web_ui_section'
import type { SectionProps } from 'nsw-ds-react/dist/component/section/section'
import { Section } from 'nsw-ds-react'
import rteSections from '@/components/sections'
import {
	getLinkedItems,
	useKontentHomeConfig,
} from '@/components/contexts/KontentHomeConfigProvider'

const SPACING_MAP: Record<string, SectionProps['padding']> = {
	full_padding: 'full',
	half_padding: 'half',
	no_padding: 'none',
}

const mapColourToStyle = (
	codename: string | undefined,
): SectionProps['style'] => {
	if (!codename) return 'white'
	return codename.replace(/_/g, '-') as SectionProps['style']
}

const mapSpacingToPadding = (
	codename: string | undefined,
): SectionProps['padding'] => {
	return SPACING_MAP[codename] || 'none'
}

export default function WebUiSectionComponent(
	props: RichtextSectionProps<WebUiSection>,
) {
	const { linkedItem, mappings } = props
	const { pageResponseLinkedItems } = useKontentHomeConfig()

	const colourCodename = linkedItem.elements.colour.value?.[0]?.codename
	const spacingCodename =
		linkedItem.elements.vertical_spacing.value?.[0]?.codename

	const style = mapColourToStyle(colourCodename)
	const padding = mapSpacingToPadding(spacingCodename)

	const childItems = getLinkedItems(
		linkedItem.elements.items,
		pageResponseLinkedItems,
	)

	if (!childItems || childItems.length === 0) return null

	return (
		<Section
			className="module"
			style={style}
			padding={padding}
			container={false}
		>
			{childItems.map((childItem) => {
				const ChildComponent = (rteSections as any)[
					childItem.system.type
				]
				if (!ChildComponent) return null
				return (
					<ChildComponent
						key={childItem.system.codename}
						linkedItem={childItem}
						mappings={mappings}
					/>
				)
			})}
		</Section>
	)
}
